import { createStore } from 'vuex';
import bootstrap from 'bootstrap/dist/js/bootstrap.min.js';
import { userService } from '@/services/UsersService';

export default createStore({
	state: {
		hideConfigButton: false,
		isPinned: true,
		showConfig: false,
		isTransparent: '',
		isRTL: false,
		color: '',
		isNavFixed: false,
		isAbsolute: false,
		showNavs: true,
		showSidenav: true,
		showNavbar: true,
		showFooter: true,
		showMain: true,
		navbarFixed:
			'position-sticky blur shadow-blur left-auto top-1 z-index-sticky px-0 mx-4',
		absolute: 'position-absolute px-4 mx-0 w-100 z-index-2',
		bootstrap,
		user: null,
		notifications: [],
		unread_count: 0,
		breadcrumbs: [],
	},
	mutations: {
		toggleConfigurator(state) {
			state.showConfig = !state.showConfig;
		},
		navbarMinimize(state) {
			const sidenav_show = document.querySelector('.g-sidenav-show');
			if (sidenav_show.classList.contains('g-sidenav-hidden')) {
				sidenav_show.classList.remove('g-sidenav-hidden');
				sidenav_show.classList.add('g-sidenav-pinned');
				state.isPinned = true;
			} else {
				sidenav_show.classList.add('g-sidenav-hidden');
				sidenav_show.classList.remove('g-sidenav-pinned');
				state.isPinned = false;
			}
		},
		setUser(state, user) {
			state.user = user;
		},
		setNotifications(state, notifications) {
			state.notifications = notifications;
		},
		setUnreadCount(state, unread_count) {
			state.unread_count = unread_count;
		},
		setBreadcrumbs(state, breadcrumbs) {
			state.breadcrumbs = breadcrumbs;
		},
		sidebarType(state, payload) {
			state.isTransparent = payload;
		},
		cardBackground(state, payload) {
			state.color = payload;
		},
		navbarFixed(state) {
			if (state.isNavFixed === false) {
				state.isNavFixed = true;
			} else {
				state.isNavFixed = false;
			}
		},
		toggleEveryDisplay(state) {
			state.showNavbar = !state.showNavbar;
			state.showSidenav = !state.showSidenav;
			state.showFooter = !state.showFooter;
		},
		toggleHideConfig(state) {
			state.hideConfigButton = !state.hideConfigButton;
		},
	},
	actions: {
		toggleSidebarColor({ commit }, payload) {
			commit('sidebarType', payload);
		},
		setCardBackground({ commit }, payload) {
			commit('cardBackground', payload);
		},
		async fetchUserInfo({ commit }) {
			try {
				const response = await userService.getInfo();
				commit('setUser', response);
			} catch (error) {
				console.error(error);
				throw error;
			}
		},
		async fetchNotifications({ commit }) {
			try {
				const response = await userService.getNotifications(1);
				commit('setNotifications', response.data);
				commit('setUnreadCount', response.unread_count);
			} catch (error) {
				console.error(error);
				throw error;
			}
		},
		updateBreadcrumbs({ commit }, breadcrumbs) {
			console.log('set-breadcrumbs', breadcrumbs);
			commit('setBreadcrumbs', breadcrumbs);
		},
	},
	getters: {
		isAuthenticated: (state) => !!state.user?.id,
		isAdmin: (state) => state.user?.role_id == 1,
		getBreadcrumbs: (state) => state.breadcrumbs,
		horseListMenuLink: (state) => {
			const roles = {
				1: 'Horses',
				2: 'StableManagerHorses',
				3: 'InstructorHorses',
				4: 'GroomHorses',
				5: 'CustomerHorses',
				6: 'VeterinarianHorses',
				7: 'FarrierHorses',
			};
			return roles[state.user?.role_id] || 'Horses';
		},
	},
});
